import React from 'react';

interface StepNavigationProps {
  currentStep: number;
  buttonName: string;
  isView?: boolean;
  contentChanged?: boolean;
  onPrevious: () => void;
  onSubmit: () => void;
}

const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStep,
  buttonName,
  isView,
  contentChanged,
  onPrevious,
  onSubmit
}) => {
  if (currentStep === 6) {
    return null;
  }

  return (
    <div className="flex justify-center sm:justify-end w-full gap-2 px-2 sm:px-0">
      <div className="flex flex-row gap-2 w-full sm:w-auto">
        {currentStep > 1 && (
          <button
            disabled={contentChanged}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              onPrevious();
            }}
            className={`w-full sm:w-[200px] z-50 px-4 py-2 rounded-md text-sm sm:text-base ${
              contentChanged
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-slate-200 text-gray-600 hover:bg-slate-300'
            }`}
          >
            Back
          </button>
        )}

        {
          <button
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            disabled={contentChanged}
            hidden={isView && currentStep === 3}
            className={`w-full sm:w-[200px] px-4 py-2 z-50 rounded-md text-sm sm:text-base
              ${(isView && currentStep === 4) || contentChanged
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-blue-500 text-white hover:bg-blue-600'}
            `}
          >
            {buttonName}
          </button>
        }
      </div>
    </div>
  );
};

export default StepNavigation;
